
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.4 30.8c-.8 0-1.5-.3-2.1-.8-1.4-1.2-1.5-3.2-.3-4.6l7.4-8.4-7.5-8.4c-1.2-1.4-1-3.4.3-4.6 1.4-1.2 3.4-1.1 4.6.3L24 14.8c1.1 1.2 1.1 3.1 0 4.3l-9.2 10.6c-.6.7-1.5 1.1-2.4 1.1z"}})])
          )
        }
      }
    